import Vue from 'vue'
import anyChat_h5_idr from './anyChat_h5_idr.vue'

// 创建AnyChat构造器
const anyChat_h5_idr_Constructor = Vue.extend(anyChat_h5_idr)
let instance

function anyChat_idr(options: any = {}, type: number | string, callBack: any) {
  // // 设置默认参数为对象，如果参数为字符串，参数中message属性等于该参数
  // if (typeof options === 'string') {
  //   options = {
  //     message: options,
  //   }
  // }
  // 创建实例
  instance = new anyChat_h5_idr_Constructor({
    data: { ...options, type },
  })

  // 注册组件的监听事件
  instance.$on('livingActionSuccess', livingActionSuccess)
  instance.$on('actionCallBack', actionCallBack)

  function livingActionSuccess(data: any) {
    console.log(data)
  }
  function actionCallBack(data: any, type: number) {
    callBack(data, type)
  }

  // 将实例挂载到body下
  document.body.appendChild(instance.$mount().$el)
}

// 将anychat组件挂载到vue原型上
Vue.prototype.$anyChat_h5_idr = anyChat_idr
